import { getActiveTabContentSections } from './notebook-layout'

/** Per theme-tab content block limits (excludes hero/tabs structural sections). */
export const TAB_BLOCK_IDEAL = 8
export const TAB_BLOCK_WARN = 10
export const TAB_BLOCK_MAX = 12

export function countActiveTabBlocks(notebook, activeTabId) {
  return getActiveTabContentSections(notebook, activeTabId).length
}

export function isTabBlockLimitReached(notebook, activeTabId) {
  return countActiveTabBlocks(notebook, activeTabId) >= TAB_BLOCK_MAX
}

/** @returns {'nudge' | 'warn' | 'max' | null} */
export function getTabBlockLimitHintLevel(count) {
  if (count >= TAB_BLOCK_MAX) return 'max'
  if (count >= TAB_BLOCK_WARN) return 'warn'
  if (count >= TAB_BLOCK_IDEAL) return 'nudge'
  return null
}

export const TAB_BLOCK_LIMIT_TOAST =
  'This tab is full (12 blocks max). Add a new tab to keep your notebook focused.'
